import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { authInterceptor } from './auth/core/auth.interceptor';
import { tenantAuthInterceptor } from './rms/core/auth/tenant-auth.interceptor';
import { routes } from './app.routes';

// Client hydration is intentionally not enabled: this app has third-party
// scripts (Chart.js canvases, GoatCounter's visitor badge) that mutate the
// DOM outside Angular's control, which breaks hydration's DOM reconciliation.
// The prerendered HTML is still served for the first paint/crawlers; the
// client then does a normal (non-hydrated) bootstrap on top of it.
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })),
    provideHttpClient(withInterceptors([authInterceptor, tenantAuthInterceptor])),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
  ]
};
